import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserdataService } from './userdata.service';

@Injectable({
    providedIn: 'root'
})
export class MentorGuardService {

    private router = inject(Router);
    private userdata = inject(UserdataService);


    async canActivate(): Promise<boolean> {
        const userData = await this.userdata.data.getValue();
        console.log("USER", userData)
        if (!userData) {
            this.router.navigate(['login']);
            return false;
        }

        if (JSON.stringify(userData.role).indexOf('ST_COACH') === -1) {
            console.log("No Coach")
            this.router.navigate(['home']);
            return false;
        }
        return true;
    }
}
